if (typeof window !== 'undefined') {
  window.process = window.process || {
    env: { NODE_ENV: 'production' },
    browser: true,
    version: '',
    nextTick: (fn) => setTimeout(fn, 0),
  };
  window.global = window.global || window;
}